import superFetch from '../utils/super-fetch';

/* global CONFIG */
const { xeroUrl } = CONFIG;
const DEFAULT_TOKEN_TTL_MS = 45 * 60 * 1000;
const TOKEN_EXPIRY_BUFFER_MS = 60 * 1000;

let xeroBearerToken;
let xeroBearerTokenExpiresAt = 0;
let xeroBearerTokenRequest;
const xeroPagesByFileId = new Map();

const getTokenExpiresAt = (result) => {
  const expiresInSeconds = Number(result?.expires_in);
  if (!expiresInSeconds) return Date.now() + DEFAULT_TOKEN_TTL_MS;
  return Date.now() + Math.max(0, expiresInSeconds * 1000 - TOKEN_EXPIRY_BUFFER_MS);
};

const fetchXeroBearerToken = () => {
  if (xeroBearerToken && Date.now() < xeroBearerTokenExpiresAt) {
    return Promise.resolve({ result: xeroBearerToken });
  }
  if (xeroBearerTokenRequest) return xeroBearerTokenRequest;

  const url = '/mbb/xero/oauth/token';
  const options = {
    method: 'GET',
  };

  xeroBearerTokenRequest = superFetch(url, options)
    .then(data => data.json())
    .then((data) => {
      if (data?.result?.access_token) {
        xeroBearerToken = data.result;
        xeroBearerTokenExpiresAt = getTokenExpiresAt(data.result);
      }
      return data;
    })
    .catch((error) => {
      xeroBearerToken = null;
      xeroBearerTokenExpiresAt = 0;
      throw error;
    })
    .finally(() => {
      xeroBearerTokenRequest = null;
    });

  return xeroBearerTokenRequest;
};

const getPagesArray = (fileId, headers) => {
  if (xeroPagesByFileId.has(fileId)) return xeroPagesByFileId.get(fileId);

  const url = `
${xeroUrl}/object:get/${fileId}`;
  const options = {
    method: 'POST',
    headers,
  };

  const pagesRequest = superFetch(url, options)
    .then(data => data.json())
    .catch((error) => {
      xeroPagesByFileId.delete(fileId);
      throw error;
    });

  xeroPagesByFileId.set(fileId, pagesRequest);
  return pagesRequest;
};

const getFileImage = (fileId, imageUrl, headers) => {
  const url = `
${xeroUrl}/object:download/${fileId}${imageUrl}`;
  const options = {
    method: 'POST',
    headers,
  };

  return superFetch(url, options).then(response => response.blob());
};

const getFileBlocks = (fileId, blockUrl, headers) => {
  const url = `
${xeroUrl}/object:download/${fileId}${blockUrl}`;
  const options = {
    method: 'POST',
    headers,
  };

  return superFetch(url, options).then(data => data.json());
};

export { fetchXeroBearerToken, getPagesArray, getFileImage, getFileBlocks };
